import { Button, Card, Form, Icon, Input, InputNumber, Select } from "antd";
import React, { useEffect, useState } from "react";
import { SplitAccountModel } from "../../../../models/split_account";
import { EaseTable } from "../../../../libs/EaseTable";
import { alertify, handleApiExceptions } from "../../../../app_methods";
import { getSplitAccountColumns } from "../../../SmartCollect/constants";
import { SplitAccountsConfigForm } from "./styles";

let SplitsConfigForm = (props) => {
    const {
        form,
        splitAccounts,
        handleSplitUpdate,
        setShowModal,
        isRetrieving,
        setSelectedSplitAccount,
        fetchSplitAccounts,
        split_settlement_type,
        virtualAccount,
        can_edit
    } = props;

    const approvedList = splitAccounts?.filter((item, index) => item.approval_status.toLowerCase() === "approved");
    const [splitType, setSplitType] = useState("");
    const [isInitialSplitType, setIsInitialSplitType] = useState(false);
    const initialSplitTypeValue = splitAccounts?.length > 0 ? splitAccounts[0]?.split_type : undefined;
    const [selectedPriorities, setSelectedPriorities] = useState([]);
    const hunderedPercentage = 100;
    const totalSplitPercentage = form.getFieldsValue().config?.reduce((total, obj) => {
        return parseFloat(total) + parseFloat(obj.split_value || 0);
    }, 0);

    const restSplitPercentage = splitType === 'percentage' ? (hunderedPercentage - totalSplitPercentage).toFixed(3) : 0.000;

    useEffect(() => {
        if (initialSplitTypeValue === splitType) setIsInitialSplitType(true);
    }, [splitType])

    // useEffect(() => {
    //     if (splitAccounts?.length > 0) {

    //     }
    // }, [splitAccounts]);

    useEffect(() => {
        if (splitAccounts?.length > 0) {
            const initialPriorities = splitAccounts.map((item) => item.priority);
            setSelectedPriorities(initialPriorities)
            setSplitType(initialSplitTypeValue);
        }
    }, [splitAccounts]);

    const configureSplitAccounts = async (values) => {
        const split_account_model = new SplitAccountModel()
        const response = split_settlement_type == "MVA" ? await split_account_model.configure({ ...values }) : await split_account_model.configure_cva({ ...values, "cva_id": virtualAccount?.id });
        if (!response.success) {
            handleApiExceptions(response);
            return;
        }
        alertify("Success", "Split Accounts Configuration Successful", "success");
        fetchSplitAccounts();
    };

    const selectSplitType = (value) => {
        setSplitType(value);
        setIsInitialSplitType(false);
        form.resetFields();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            configureSplitAccounts({ split_type: splitType, config: values.config });
        });
    };


    const renderFooter = () => {
        return (
            <>
                {can_edit ? (
                    <div className="footer mt-5">
                        {splitType === "percentage" &&
                            (restSplitPercentage < 0 ? (
                                <div className="ml-4">Total Split Percentage should be 100.</div>
                            ) : (
                                <p className="m-0 ml-4">
                                    Total Split Percentage should be 100. Remaining value = {restSplitPercentage} %
                                </p>
                            ))}
                        <div className="btn">
                            <Button
                                disabled={
                                    approvedList.length == 0
                                        ? true
                                        : splitType === "percentage"
                                            ? restSplitPercentage != 0
                                            : false
                                }
                                className="ml-auto"
                                htmlType="submit"
                                type="primary"
                            >
                                Save
                            </Button>
                        </div>
                    </div>) : null}
            </>
        );
    };

    return (
        <SplitAccountsConfigForm splitType={splitType} onSubmit={handleSubmit}>
            <div className="form-header d-flex justify-content-between mt-3">
                {approvedList.length !== 0 && can_edit ? (
                    <div>
                        <label className="mr-2 label" htmlFor="select-split-type">
                            Select Split Type
                        </label>
                        <Select
                            id="select-split-type"
                            value={splitType}
                            placeholder="Split Type"
                            className=""
                            onChange={selectSplitType}
                            autoComplete="off"
                            prefix={<Icon type="profile" />}
                        >
                            <Select.Option key="percentage" value="percentage">
                                Percentage
                            </Select.Option>
                            <Select.Option key="flat" value="flat">
                                Flat
                            </Select.Option>
                        </Select>
                    </div>
                ) : null}
                <Button
                    className="ml-auto"
                    type="secondary"
                    loading={isRetrieving}
                    onClick={() => {
                        setShowModal(true);
                        setSelectedSplitAccount(null);
                    }}
                >
                    Create Split Account
                </Button>
            </div>
            <>
                {splitAccounts?.length > 0 ? <EaseTable
                    className="w-100 mt-1"
                    rowKey="id"
                    data={splitAccounts}
                    columns={getSplitAccountColumns({
                        handleSplitUpdate,
                        isInitialSplitType,
                        splitType,
                        form,
                        selectedPriorities,
                        setSelectedPriorities,
                        splitAccounts,
                        approvedList,
                        split_settlement_type,
                        can_edit
                    })}
                /> : null}
                {renderFooter()}
            </>
        </SplitAccountsConfigForm>
    );
};

SplitsConfigForm = Form.create()(SplitsConfigForm);
export { SplitsConfigForm };
